import { msg } from "../locales/translate.ts";
import type { CursorPage } from "../modules/cursorExport/cursorExport";

export const sessionExportRequestData = (data: Record<string, unknown>, cursor?: string) => {
	const { download: _download, pagination: _pagination, per_page: _perPage, perPage: _legacyPerPage, ...filters } = data;
	return { ...filters, cursor: cursor ?? "" };
};

export function parseSessionExportPage<Row>(data: any): CursorPage<Row> {
	const rows = data?.items ?? data?.rows;
	const pages = data && Object.prototype.hasOwnProperty.call(data, "next_cursor") ? data : data?.pages ?? data?.pagination;
	const nextCursor = pages?.next_cursor;
	if (!Array.isArray(rows) || (nextCursor !== null && (typeof nextCursor !== "string" || !nextCursor.trim()))) {
		throw new Error(msg("missingOrInvalidSessionExportPaginationTheFileWasNotSaved"));
	}
	// For session/list, only next_cursor determines completion; total is not a bound.
	return { rows, nextCursor };
}
